/* eslint-disable @typescript-eslint/no-explicit-any */
import { ElementRef, Injectable, signal } from '@angular/core';

import {
  DragArea,
  MovableCardsContainerSingleColumnGroup,
  MovableCardsContainerTwoColumnsGroup,
  SimpleDomRect,
} from '../movable-cards-container.view-model';

@Injectable()
export class StateService<T extends string = string> {
  public readonly initialKeyBoundingRectMap: Record<string, SimpleDomRect> = {};
  public stableGroups = signal<(MovableCardsContainerSingleColumnGroup<T> | MovableCardsContainerTwoColumnsGroup<T>)[]>([]);
  public groupsDuringDrag!: (MovableCardsContainerSingleColumnGroup<T> | MovableCardsContainerTwoColumnsGroup<T>)[];
  public cardContainerRect = signal<SimpleDomRect>(null as any);
  public readonly rowGapSize = 24;
  public readonly columnGapSize = 24;
  public swapFnResultCache: Record<string, (MovableCardsContainerSingleColumnGroup<T> | MovableCardsContainerTwoColumnsGroup<T>)[]> = {};
  public keyContainerMap!: Record<string, ElementRef<HTMLElement>>;
  public readonly keyTransformMap = signal<Record<string, string>>({});
  public dragAreas = signal<DragArea<T>[]>([]);
  public containerMinHeight = signal<number | null>(null);
  public draggedCardKey!: string;
  public dragIsInProgress = signal<boolean>(false);

  public patchInitialKeyBoundingRectMap(key: string, rect: SimpleDomRect): void {
    this.initialKeyBoundingRectMap[key] = rect;
  }

  public setCardContainerRect(rect: SimpleDomRect): void {
    this.cardContainerRect.set(rect);
  }

  public cacheSwapFnResult(
    key: string,
    result: (MovableCardsContainerSingleColumnGroup<T> | MovableCardsContainerTwoColumnsGroup<T>)[]
  ): void {
    this.swapFnResultCache[key] = result;
  }

  public clearSwapFnCache(): void {
    this.swapFnResultCache = {};
  }

  public setStableGroups(groups: (MovableCardsContainerSingleColumnGroup<T> | MovableCardsContainerTwoColumnsGroup<T>)[]): void {
    this.stableGroups.set(groups);
  }

  public setGroupsDuringDrag(groups: (MovableCardsContainerSingleColumnGroup<T> | MovableCardsContainerTwoColumnsGroup<T>)[]): void {
    this.groupsDuringDrag = groups;
  }

  public setKeyTransformMap(map: Record<string, string>): void {
    this.keyTransformMap.set(map);
  }

  public setDragAreas(areas: DragArea<T>[]): void {
    this.dragAreas.set(areas);
  }

  public setDraggedCardKey(key: string): void {
    this.draggedCardKey = key;
  }

  public setContainerMinHeight(height: number | null): void {
    this.containerMinHeight.set(height);
  }

  public setKeyContainerMap(map: Record<string, ElementRef<HTMLElement>>): void {
    this.keyContainerMap = map;
  }

  public setDragIsInProgress(isInProgress: boolean): void {
    this.dragIsInProgress.set(isInProgress);
  }
}
